import React, { createContext, useContext, useState, useEffect } from "react";

const LoadingContext = createContext();

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error("useLoading must be used within LoadingProvider");
  }
  return context;
};

export const LoadingProvider = ({ children }) => {
  // Check sessionStorage immediately - it persists on refresh but is fresh on new tab
  const hasSeenSplash = sessionStorage.getItem("splashScreenShown") === "true";

  const [showSplash, setShowSplash] = useState(!hasSeenSplash);
  const [showRefresh, setShowRefresh] = useState(hasSeenSplash);
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    // Mark splash as shown in this tab
    if (showSplash) {
      sessionStorage.setItem("splashScreenShown", "true");
    }
  }, [showSplash]);

  const handleSplashComplete = () => {
    setShowSplash(false);
    setIsInitializing(false);
  };

  const handleRefreshComplete = () => {
    setShowRefresh(false);
    setIsInitializing(false);
  };

  const value = {
    showSplash,
    showRefresh,
    isInitializing,
    handleSplashComplete,
    handleRefreshComplete,
  };

  return (
    <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>
  );
};
